import React, { useEffect, useState, useRef } from 'react'

import { ScrollView, View, StyleSheet, Keyboard, TouchableOpacity, Text, Platform, Linking } from 'react-native'
import delay from 'delay'

import ApiClient from "../bff-client/src/ApiClient";
import BasketsApi from "../bff-client/src/api/BasketsApi";
import ProductsApi from "../bff-client/src/api/ProductsApi";
import discountsHelper from '../util/discountsHelper';

import {
  Price,
  Space,
  KeyboardAvoidingView,
  Button,
  AnimatedEllipsis,
  ProductListItem,
  TextInput
} from '@sart/components'
import { adaptive, backgroundColors, colors, typography, radius } from '@sart/styles'
import client, { orderHelper, useData } from '@sart/client'
import { useContent } from '@sart/content'

import * as theme from '../Sign/signTheme'

import AppConfig from '../Configuration/AppConfig';
import { testID } from '@sart/utilities'
import { set } from 'lodash-es'

export default function PurchaseAddonReview(props) {
  const { navigation, route } = props
  const product = route.params?.product
  const [promoCode, setPromoCode] = useState('')
  const [validationError, setValidationError] = useState('')
  const [discountDisplay, setDiscountDisplay] = useState('')
  const [discountValidated, setDiscountValidated] = useState(false)
  const [discountProcessing, setDiscountProcessing] = useState(false)
  const [discountProduct, setDiscountProduct] = useState(null)

  const bffClient = new ApiClient(AppConfig.bffBasePath)
  bffClient.defaultHeaders = {
    ...bffClient.defaultHeaders,
    Origin: AppConfig.shopOriginUrl
  }

  const basketsApi = new BasketsApi(bffClient);
  const productsApi = new ProductsApi(bffClient);

  const {
    customer,
    user
  } = client.cache

  const [{ loading, error }, setData] = useData({ loading: false })

  const content = useContent()

  useEffect(() => {
    if (!discountProduct) {
      getDiscountProduct();
    }
  }, []);


  async function getDiscountProduct() {
    const discountProducts = await productsApi.productsGet({ "category": "modifyservicedetails" });
    const discountProduct = discountProducts.find(p => p.legacyId === AppConfig.applyDiscountProduct);
    setDiscountProduct(discountProduct);
    return discountProduct;
  }

  async function applyOrRemoveDiscount() {

    setDiscountProcessing(true);
    setValidationError(null);

    if (discountValidated) {
      //already have a discount applied, so remove it
      setPromoCode("");
      setDiscountDisplay("");
      setDiscountValidated(false);
    } else {
      //apply discount
      try {
        console.log('discount not yet validated, so adding it');

        console.log('discount product is: ' + JSON.stringify(discountProduct, null, 2));

        if (!discountProduct) {
          await getDiscountProduct();
        }

        //trim any leading or trailing whitespace from the code
        console.log('username is: ' + customer.user.userName);
        const discountExtendedData = {
          promoCode: promoCode?.trim(),
          emailAddress: customer.user.userName
        }
        console.log('discountExtendedData: ' + JSON.stringify(discountExtendedData, null, 2));

        const serviceItems = [{ productId: product.productId }, { productId: discountProduct.id, extendedData: discountExtendedData }];

        const basketsPostRequest = {
          serviceItems: serviceItems,
          channel: AppConfig.channelName
        }

        console.log('basketsPostRequest: ' + JSON.stringify(basketsPostRequest, null, 2));

        const basket = await basketsApi.basketsPost({ basketsPostRequest });
        console.log('validating basket: ' + JSON.stringify(basket, null, 2));
        const validationResponse = await basketsApi.basketsValidatePost(basket);
        console.log("validationResponse: " + JSON.stringify(validationResponse, null, 2));

        //any successful non-error response means validation has passed according to the API doc
        setDiscountValidated(true);
        setDiscountDisplay(validationResponse.coupon)

      } catch (error) {
        console.log("Error validating discount: " + JSON.stringify(error, null, 2));
        if (error.body?.validationErrors?.length > 0 && error.body?.validationErrors[0]?.errors?.length > 0) {
          const errorCode = discountsHelper.getHighestPriorityErrorCode(error.body?.validationErrors[0]?.errors);
          console.log("errorCode: " + errorCode);
          const errorMessage = content.errors.promoCodeErrors[errorCode] || "Other Problem";
          setValidationError(errorMessage);
        } else {
          setValidationError('Invalid Discount Code');
        }
        setDiscountValidated(false);
      }
    }
    setDiscountProcessing(false);
  }

  async function processAddOnPurchase() {
    Keyboard.dismiss()
    console.log("Submitting add on purchase, product is: " + JSON.stringify(product, null, 2));

    setData({ loading: true, error: null })
    try {

      if (product) {
        //create hosted payment
        let basket
        let gatewayResponse
        basket = await client.createBasket()
        console.log('created basket is: ' + JSON.stringify(basket, null, 2));
        basket = await client.addServiceProductToBasket(basket, product, undefined)
        console.log('basket after adding product is: ' + JSON.stringify(basket, null, 2));

        if (discountValidated && discountProduct && promoCode) {
          console.log('discountProduct is: ' + JSON.stringify(discountProduct, null, 2));
          discountProduct.productId = discountProduct.id;
          const discountExtendedData = {
            promoCode: promoCode?.trim(),
            emailAddress: customer.user.userName
          }
          basket = await client.addServiceProductToBasket(basket, discountProduct, discountExtendedData)
          console.log('basket after adding discount is: ' + JSON.stringify(basket, null, 2));
        }

        basket = await client.confirmBasket(basket)
        console.log('basket after confirming is: ' + JSON.stringify(basket, null, 2));

        gatewayResponse = await client.payForBasketWithHostedPayment(basket, 'stripe')
        console.log('gatewayResponse: ' + JSON.stringify(gatewayResponse, null, 2))

        // navigation.navigate('HostedPayment', gatewayPayment)
        Linking.openURL(gatewayResponse.gatewayURL)

      }

      setData({ loading: false, error: null })


    } catch (error) {
      console.log(error);
      // const message = prettyErrorMessage(error)

      // form.setFieldError('gender', message)
      setData({ loading: false, error: 'Add On purchase failed, please try again later' })
    }
  }


  return (
    <KeyboardAvoidingView style={styles.container}>
      <ScrollView contentContainerStyle={styles.contentContainer}
      // ref={scrollViewRef}
      >
        <View style={styles.widthRestrictions}>
          {product &&
            <>
              <Text style={styles.descriptionStyle}>Please confirm that you would like to purchase the following Add On: </Text>

              <Space height={16} />

              <ProductListItem
                disabled={true}
                product={product}
                priceStyle={styles.price}
                placeholderStyle={styles.productStyle}
                bodyStyle={styles.body}
                imageColor={colors.white}
                // language={language}
                injectedContent={content}
              />
            </>
          }
          <Space height={24} />

          <View style={{ flexDirection: 'row', alignItems: 'center', width: '100%' }}>
            <View style={{ flex: 3, marginRight: 16 }}>
              <TextInput
                label={content.forms.promoCodeLabel}
                placeholder={content.forms.promoCodePlaceholder}
                value={promoCode}
                onChangeText={setPromoCode}
                // onBlur={() => { }}
                // error={form.touched.promoCode && form.errors.promoCode}
                {...theme.textInput}
                autoCapitalize="characters"
                autoCorrect={false}
                disabled={discountValidated}
                {...testID('promoCode')}
              />
            </View>
            <View style={{ flex: 2 }}>
              <Button
                title={discountValidated ? 'Remove' : 'Apply'}
                onPress={applyOrRemoveDiscount}
                style={styles.enabled}
                disabledStyle={styles.disabled}
                titleStyle={{ ...typography.bold, fontSize: 12, color: colors.white }}
                disabledTitleStyle={{ ...typography.bold, fontSize: 12, color: colors.white + 45 }}
                disabled={discountProcessing}
                {...testID('applyPromoCode')}
              />
            </View>
          </View>

          {validationError &&
            <Text style={styles.errorText}>
              {validationError}
            </Text>
          }

          {discountValidated && discountDisplay &&
            <Text style={styles.discountText}>
              {content.discounts.discountCodeAppliedMessage(discountDisplay.name)}
            </Text>
          }

          <Space height={12} />


          {error &&
            <Text style={styles.errorText}>
              {error}
            </Text>
          }
          <Button
            title={
              loading
                ? <AnimatedEllipsis style={{ fontSize: 24, color: colors.clear, ...typography.extrabold }} />
                : content.common.submit
            }
            onPress={processAddOnPurchase}
            style={styles.enabled}
            disabledStyle={styles.disabled}
            titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
            disabledTitleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white + 45 }}
            {...testID('addOnPurchaseSubmit')}
          />
        </View>
      </ScrollView>
    </KeyboardAvoidingView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 24,
    paddingBottom: 0,
    backgroundColor: backgroundColors.darkCharcoal,
    ...adaptive.wrapperPadding
  },
  contentContainer: {
    ...Platform.select({
      web: {
        alignItems: 'center'
      }
    })
  },
  dateStyle: {
    fontSize: 16,
    lineHeight: 22,
    color: colors.white,
    ...typography.demi
  },
  planContainer: {
    padding: 12,
    backgroundColor: backgroundColors.darkCharcoal,
    borderRadius: radius.medium,
    elevation: 8,
    // ...shadows.shadowByElevation(8),
    borderColor: colors.white,
    borderWidth: 1
  },
  planStyle: {
    fontSize: 20,
    lineHeight: 48,
    fontWeight: '700',
    color: colors.brightOrange
  },
  descriptionStyle: {
    fontSize: 16,
    lineHeight: 20,
    color: colors.white,
    ...typography.demi,
  },
  descriptionnNoPlanStyle: {
    fontSize: 16,
    lineHeight: 16,
    color: colors.srTextInput,
    ...typography.demi,
  },
  descriptionContentStyle: {
    fontSize: 16,
    lineHeight: 24,
    color: colors.white,
    ...typography.demi
  },
  description: {
    textAlign: 'center',
    ...typography.lightbold,
    color: colors.brightOrange
  },
  discountText: {
    paddingTop: 8,
    fontSize: 12,
    lineHeight: 20,
    color: colors.white,
    ...typography.demi,
  },
  selectStyle: {
    ...typography.demi
  },
  curpFooter: {
    ...typography.demi,
    color: colors.brightOrange,
    alignContent: 'flex-end',
    textDecorationLine: 'underline'
  },
  inputWrapper: {
    flexDirection: 'row',
  },
  nestedInputs: {
    flex: 1
  },
  inputStyle: {
    height: 300
  },
  enabledButton: {
    backgroundColor: colors.brightOrange,
  },
  disabledButton: {
    backgroundColor: colors.brightOrange + 50
  },
  label: {
    color: colors.brightOrange,
    ...typography.lightbold,
    fontSize: 16
  },
  helpIcon: {
    justifyContent: 'center'
  },
  helpPointContainer: {
  },
  helpPointText: {
    ...typography.medium,
    color: colors.brightOrange,
    fontSize: 14
  },
  noId: {
    ...typography.demi,
  },
  labelStyles: {
    color: colors.brightOrange,
    ...typography.demi
  },
  enabled: {
    backgroundColor: colors.brightOrange,
  },
  disabled: {
    backgroundColor: colors.brightOrange + 60,
    borderColor: colors.brightOrange + 60,
    borderWidth: 1
  },
  subTitle: {
    ...typography.lightbold,
    color: colors.white
  },
  errorText: {
    color: 'red',
    marginTop: 8,
    marginBottom: 8,
  },
  widthRestrictions: {
    width: '100%',
    maxWidth: 600,
    paddingBottom: 20
  }
})

const selectStyle = {
  control: (base) => ({
    ...base,
    ...typography.demi,
  }),
  menu: (base) => ({
    ...base,
    ...typography.demi
  })
};